import { RugbyLeagueIncidentId } from '@collector/sportsapi-client-legacy'

import { LastIncidentsConfig } from '../../../configuration'
import { incidentsUpdate } from '../../configuration'

const incidentsToTrackUpdate = new Set([RugbyLeagueIncidentId.EntryInto20])

export const lastIncidentsConfig: LastIncidentsConfig = {
  incidentsUpdate: (...args) =>
    incidentsUpdate(...args, incidentsToTrackUpdate),
}
